import { TextField } from '@mui/material'
import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import React from 'react'

import { editorSx } from './editorStyles'

export const NumberEditor: React.FC<GridRenderEditCellParams> = (params) => {
	const apiRef = useGridApiContext()
	const value = params.value as number | string | null | undefined
	return (
		<TextField
			type="number"
			value={value ?? ''}
			onChange={(e) => {
				const next = e.target.value === '' ? null : Number(e.target.value)
				apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: next })
			}}
			size="small"
			fullWidth
			autoFocus
			placeholder={params.colDef.headerName ?? ''}
			sx={editorSx}
		/>
	)
}
